import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { RecommendationItem } from '../../server/types.js';
import WarpElement from '@warp-ds/elements-core';
import './cross-brand-card.js';
import { i18n } from '@lingui/core';

@customElement('advertising-card')
export class AdvertisingCard extends WarpElement {
	static styles = [
		...WarpElement.styles,
		css`
			/** The line below is where the injected CSS goes, removing it means you get no CSS from the design system **/
			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.static{position:static}.hover\:s-bg-hover:hover{background-color:var(--w-s-color-background-hover)}.active\:s-bg-active:active{background-color:var(--w-s-color-background-active)}.hover\:s-border-hover:hover{border-color:var(--w-s-color-border-hover)}.active\:s-border-active:active{border-color:var(--w-s-color-border-active)}.hover\:s-surface-elevated-200-hover:hover{background-color:var(--w-s-color-surface-elevated-200-hover);box-shadow:var(--w-s-shadow-surface-elevated-200-hover)}.active\:s-surface-elevated-200-active:active{background-color:var(--w-s-color-surface-elevated-200-active);box-shadow:var(--w-s-shadow-surface-elevated-200-active)}.isolate{isolation:isolate};
		`,
	];

	item!: RecommendationItem;
	url!: string;
	data!: { items: RecommendationItem[] };

	static properties = {
		item: { type: Object },
		url: { type: String },
		data: { type: Object },
		locale: { type: String },
	}

	firstUpdated() {
		if (this.item.type === 'oikotie') {
			const oikotieAd = this.shadowRoot?.querySelector('#oikotie-ad');
			oikotieAd?.insertAdjacentHTML(
				'afterbegin',
				`<iframe
					title="${i18n.t({
						id: 'frontpage.oikotie.ad.title',
						message: 'Oikotie ad',
					})}"
					src="https://recommendations.asunnot.oikotie.fi/tori-aurora-front-page.html"
					class="relative isolate recommendation-ad card card--cardShadow s-bg"
					width="100%"
					height="100%"
				></iframe>`,
			);
		}
	}

	render() {
		if (!this.item) return html``;

		// Handle special ad types
		if (this.item.type === 'oikotie') {
			return this.oikotieAd();
		}

		if (this.item.type === 'CROSSBRAND') {
			return html`
				<cross-brand-card
					.item="${this.item}"
					.data="${this.data}"
					.locale="${this.locale}"
				></cross-brand-card>
			`;
		}
	}

	// Render the Oikotie ad
	private oikotieAd() {
		return html`
			<div
				class="h-full cursor-pointer overflow-hidden relative transition-all group rounded-8 s-surface-elevated-200 hover:s-surface-elevated-200-hover active:s-surface-elevated-200-active s-bg hover:s-bg-hover active:s-bg-active s-border hover:s-border-hover active:s-border-active"
				id="oikotie-ad"
				tabindex="0"
			></div>
		`;
	}
}
